module.exports = __webpack_public_path__ + "img/picto-sur-mesure.22c6ccd9.svg";